import React from 'react';
import { shape, string } from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';
import { publish } from '../../utils/publisher';
import './CategoryTile.scss';

const CategoryTile = (props) => {
  const { category, componentName } = props;

  const handleClickedCategory = (clickedCategory) => {
    publish({
      componentName,
      eventName: 'click',
      data: clickedCategory,
    });
  };

  return (
    <article key={category?.id} className="product__container" data-type="product">
      <meta data-prop="name" content={category?.title} />
      <div className="product__img_link_container">
        <a href={category?.catUrl} onClick={() => handleClickedCategory(category)}>
          <div className="product__image-container">
            <Image
              alt={category?.title}
              className="product__image"
              src={category?.catImage?.replace('<SIZE>', '400')}
              height="183px"
              width="183px"
            />
          </div>
          <div className="product__description">
            <span>{category?.title}</span>
          </div>
        </a>
      </div>
    </article>
  );
};

CategoryTile.displayName = 'CategoryTile';

CategoryTile.propTypes = {
  category: shape({
    id: string,
    title: string,
    catUrl: string,
    catImage: string,
  }).isRequired,
  componentName: string,
};

CategoryTile.defaultProps = {
  componentName: '',
};

export { CategoryTile };
